/**
 * Returns a boolean indicating whether the current environment is a client browser.
 */
export const isClient = () => {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
};
//# sourceMappingURL=is-client.js.map